import React, { useState, useEffect, useCallback } from "react";
import { Row, Col, Space, Card, TimePicker } from "antd";
import { List, Button, Modal, Toast, message } from "antd-mobile";
import ajaxService from "../services/ajax-service";
import { withLocalize } from "react-localize-redux";
import SearchModal from "./search-modal";
import { useHistory, useLocation, useParams } from "react-router-dom";
import Layout from "../layout";
import { masalik } from "../constants";
import moment from "moment";

const MasjidTimings = ({ translate, activeLanguage }) => {
  const history = useHistory();
  const [namaz, setNamaz] = useState({});
  const [namaz_timings, setNamazTimings] = useState({});
  const [masjid, setMasjid] = useState();
  const [updatedTimings, setUpdatedTimings] = useState({});

  let { id } = useParams();

  const updateTimings = async (id, values) => {
    const formattedData = {
      masjid_id: masjid.id,
      ...values,
    };

    try {
      const NamazTimings = {
        fajr: namaz_timings.fajr[1],
        zoher: namaz_timings.zoher[1],
        asar: namaz_timings.asar[1],
        maghrib: namaz_timings.maghrib[1],
        isha: namaz_timings.isha[1],
        juma: namaz_timings.juma[1],
      };

      const namazKeys = ["fajr", "zoher", "asar", "maghrib", "isha", "juma"];
      const hasInvalidTimings = namazKeys.some(
        (key) => namaz_timings[key] === "N/A" || values[key] === undefined
      );

      if (!hasInvalidTimings || NamazTimings.fajr !== "N/A") {
        let response = await ajaxService.post(
          "namaz-time/" + id,
          formattedData
        );
        history.push({ pathname: "/home" });
      } else {
        Toast.show({
          content: translate("namaz_timing_required"),
          duration: 2000,
        });
      }
    } catch (error) {
      console.error("Error updating timings:", error);
    }
  };


  const handleTimeChange = (time, item) => {
    setUpdatedTimings((prev) => ({
      ...prev,
      [item]:
        item === "maghrib"
          ? time
          : time
            ? moment(time, "HH:mm:ss").format("HH:mm:ss")
            : "N/A",
    }));
  };



  // const handleTimeChange = (time, item) => {
  //   setUpdatedTimings((prev) => ({
  //     ...prev,
  //     [item]: time ? time.format("HH:mm:ss") : "N/A",
  //   }));
  // };

  const renderNamaz = () => {
    if (Object.keys(namaz).length > 0) {
      if (activeLanguage.code === "en") {
        return (
          <div>
            <List mode="card">
              <List.Item>{translate("home")}</List.Item>
            </List>
            <List mode="card">
              <List.Item>
                <Row>
                  <Col span={6}>{translate("namaz")}</Col>
                  <Col span={18} style={{ textAlign: "right" }}>
                    {translate("jamat")}
                  </Col>
                </Row>
              </List.Item>
              {Object.keys(namaz_timings).map((item, index) => {
                return (
                  <List.Item key={`namaz_timings-item-${index}`}>
                    <Row>
                      <Col span={6}>{translate(item)}</Col>
                      <Col span={18} style={{ textAlign: "right" }}>

                        {item === "maghrib" ? (() => {
                          // Debug log to see what's coming in
                          console.log("Maghrib debug:", {
                            item,
                            rawTiming: namaz_timings[item][1],
                            updatedTiming: updatedTimings[item],
                            finalValue:
                              updatedTimings[item] !== undefined
                                ? updatedTimings[item]
                                : namaz_timings[item][1] === "N/A"
                                  ? ""
                                  : namaz_timings[item][1],
                          });

                          return (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "flex-end",
                                gap: "8px",
                              }}
                            >
                              <span>Enter</span>
                              <input
                                type="number"
                                min="0"
                                max="59"
                                placeholder="Enter minutes"
                                value={
                                  updatedTimings[item] !== undefined
                                    ? updatedTimings[item]
                                    : namaz_timings[item][1] === "N/A"
                                      ? ""
                                      : namaz_timings[item][1]
                                }
                                onChange={(e) =>
                                  handleTimeChange(e.target.value ? e.target.value : "N/A", item)
                                }
                                style={{
                                  width: "80px",
                                  textAlign: "center",
                                  borderRadius: "8px",
                                  border: "1px solid #ccc",
                                  padding: "5px",
                                  fontSize: "14px",
                                }}
                              />
                              <span>minutes</span>
                            </div>
                          );
                        })() : (
                          <TimePicker
                            defaultValue={
                              namaz_timings[item][1] === "N/A"
                                ? null
                                : moment(namaz_timings[item][1], "hh:mm A").isValid()
                                  ? moment(namaz_timings[item][1], "hh:mm A")
                                  : null
                            }
                            onChange={(time) => handleTimeChange(time, item)}
                            format="hh:mm A"
                          />
                        )}

                      </Col>
                    </Row>
                  </List.Item>
                );
              })}

              <List.Item>
                <Button
                  block
                  color="primary"
                  size="medium"
                  onClick={() => updateTimings(id, updatedTimings)}
                >
                  {translate("update_timings")}
                </Button>
              </List.Item>
            </List>
          </div>
        );
      } else {
        return (
          <div>
            <List mode="card">
              <List.Item>{translate("home")}</List.Item>
            </List>
            <List mode="card">
              <List.Item>
                <Row>
                  <Col span={6}>{translate("namaz")}</Col>
                  <Col span={18} style={{ textAlign: "center" }}>
                    {translate("jamat")}
                  </Col>
                </Row>
              </List.Item>
              {Object.keys({ ...namaz_timings, juma: namaz_timings.juma || ["Juma", "N/A"] }).map(
                (item, index) => {
                  return (
                    <List.Item key={`namaz-item-` + index}>
                      <Row>
                        <Col span={6}>{translate(item)}</Col>
                        <Col span={18} style={{ textAlign: "left" }}>
                          {namaz[item][1] == "N/A" ? (
                            <TimePicker />
                          ) : (
                            <TimePicker defaultValue={namaz[item][1]} />
                          )}
                        </Col>
                      </Row>
                    </List.Item>
                  );
                })}
              <List.Item>
                <Button block color="primary" size="medium">
                  {translate("update_timings")}
                </Button>
              </List.Item>
            </List>
          </div>
        );
      }
    }
  };

  const renderMasjid = () => {
    if (masjid !== undefined) {
      const maslakKey = masalik[masjid.maslak];
      const maslakText = maslakKey ? translate(maslakKey) || "N/A" : "N/A";
      return (
        <div>
          <List mode="card">
            <List.Item>
              {activeLanguage.code === "en" ? masjid.name : masjid.name_ur}
            </List.Item>
          </List>
          <List mode="card">
            <List.Item>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <span>{translate("maslak")}</span>
                <span>{maslakText}</span>
                {/* <span>{translate(masalik[masjid.maslak])}</span> */}
              </div>
            </List.Item>
            <List.Item>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <span>{translate("contact")}</span>
                <span>{masjid.phone}</span>
              </div>
            </List.Item>
          </List>
        </div>
      );
    }
  };

  useEffect(() => {
    const getMasjidDetails = async () => {
      let response = await ajaxService.get("masjid/view/" + id);

      if (response.data) {
        let { masjid, namaz, namaz_timings } = response.data;
        namaz_timings = { ...namaz_timings, juma: namaz_timings.juma || ["Juma", "N/A"] };
        setMasjid(masjid);
        setNamaz(namaz);
        setNamazTimings(namaz_timings);
      }
    };

    getMasjidDetails();
  }, []);

  return (
    <Layout>
      <div style={{ marginLeft: "30px", marginRight: "30px" }}>
        <Space direction="vertical" size="large" style={{ width: "100%" }}>
          {renderMasjid()}
          {renderNamaz()}
        </Space>
      </div>
    </Layout>
  );
};

export default withLocalize(MasjidTimings);
